import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from '../context/LocationContext';
import { FaMapMarkerAlt, FaExchangeAlt } from 'react-icons/fa';

/**
 * Shows currently active branch at top of each page.
 * If no locations exist yet → shows nothing.
 */
const LocationBanner = () => {
  const { activeLocation, locations, isOwner } = useLocation();
  const navigate = useNavigate();

  // Single-location or no branch yet → no banner
  if (!activeLocation) return null;

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 10,
      padding: '8px 14px', borderRadius: 10, marginBottom: 20,
      background: '#fff7ed', border: '1px solid #fed7aa',
      fontSize: 13,
    }}>
      <FaMapMarkerAlt style={{ color: '#f97316', flexShrink: 0 }} />
      <span style={{ flex: 1, color: '#92400e', fontWeight: 600 }}>
        Aktiv filial: <strong>{activeLocation.name}</strong>
        {activeLocation.city && ` — ${activeLocation.city}`}
      </span>
      {isOwner && locations.length > 1 && (
        <button
          onClick={() => navigate('/locations')}
          style={{
            display: 'flex', alignItems: 'center', gap: 4,
            padding: '4px 10px', borderRadius: 6, border: '1px solid #fed7aa',
            background: '#fff', color: '#f97316', fontSize: 12,
            fontWeight: 600, cursor: 'pointer',
          }}
        >
          <FaExchangeAlt style={{ fontSize: 10 }} />
          Dəyiş
        </button>
      )}
    </div>
  );
};

export default LocationBanner;
